import Symbol from 'es6-symbol';

const EXPLORE_API = Symbol('Explore API');
export default EXPLORE_API;
